<div *ngIf='componentReady' class='BlockDates'>
  <div class='BlockDates__header d-flex flex-column flex-sm-row justify-content-between mb-5'>
    <div class='BlockDates__header__title d-flex flex-column flex-sm-row justify-content-between'>
      <h3>Blocked Dates</h3>
      <app-button *ngIf='sessionData.user_type === "master"' [Click]='insightsButtonProperties.onClick'
                  [color]='insightsButtonProperties.color'
                  [size]='insightsButtonProperties.size'
                  [text]='insightsButtonProperties.text' class='ms-3'></app-button>
    </div>
    <app-button [color]='createNewButtonProperties.color' [route]='createNewButtonProperties.route'
                [size]='createNewButtonProperties.size' [text]='createNewButtonProperties.text'></app-button>
  </div>
  <div class='BlockDates__table'>
    <app-table [columns]='tableColumns' [dataSourceParams]='dataSourceParams' [dataSource]='dataSource'></app-table>
  </div>
</div>